var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$.select, _vm.$.group_by] }, [
    _vm.isBoardConfigLoading
      ? _c(
          "div",
          [
            _c("skeleton-item", {
              style: { height: "24px", width: "116px", marginRight: 0 },
              attrs: { type: "bar" },
            }),
          ],
          1
        )
      : _c(
          "div",
          {
            class: [_vm.$.picker, _vm.isContextOpened ? _vm.$.active : ""],
            on: {
              click: function (ref) {
                var currentTarget = ref.currentTarget

                return _vm.toggleContextMenu(currentTarget)
              },
            },
          },
          [
            _c("div", { class: _vm.$.label }, [
              _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.$.active }, [
              _vm._v("\n      " + _vm._s(_vm.groupingName) + "\n    "),
            ]),
            _vm._v(" "),
            _c("svg-sprite", {
              attrs: {
                name: _vm.isContextOpened ? "arrow-top" : "arrow-down",
                size: 20,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }